import { BenefitType } from "../../../common/interfaces/enums/BenefitType";
import { HttpMethod } from "../../enums/HttpMethod";
import { PaymentFrequency } from "../../../common/interfaces/enums/PaymentFrequency";
import SortBy from "../../enums/SortBy";
import { ISpecialOffer } from "../../interfaces/ISpecialOffer";
import IQuoteCardResult from "../../interfaces/results/IQuoteCardResult";
import { apiFetch } from "../helpers";

interface IApiLog {
    groupId: string;
    sortBy: SortBy;
    paymentFrequency: PaymentFrequency;
    quoteCards: {
        provider: number;
        position: number;
        premium: number;
        hasSpecialOffer: boolean;
        quoteCardProducts: {
            caseId: number;
            productId: number;
            benefitType: BenefitType;
        }[];
    }[];
}

export const logQuoteAPI = async (
    sortBy: SortBy,
    results: IQuoteCardResult[],
    groupId: string
): Promise<void> => {
    const log: IApiLog = {
        groupId: groupId,
        sortBy: sortBy,
        paymentFrequency: results[0]?.result?.paymentFrequency,
        quoteCards: results.map((card: IQuoteCardResult, index) => {
            const { result, specialOffers, state } = card;

            const validSpecialOffers = specialOffers.filter((offer: ISpecialOffer) => {
                if (offer.specialOfferName.toLowerCase().includes("cashback"))
                    return false;
                return true;
            });

            return {
                provider: result?.providerId,
                position: index + 1,
                premium: state?.hasBlockingError ? 0 : result?.totalPremium,
                hasSpecialOffer: validSpecialOffers.length > 0,
                quoteCardProducts: result.benefits
                    .filter(
                        (benefit) => benefit.benefitType != BenefitType.WaiverOfPremium
                    )
                    .map((benefit) => {
                        return {
                            caseId: benefit?.caseId,
                            productId: benefit?.productId,
                            benefitType: benefit.benefitType
                        };
                    })
            };
        })
    };

    return apiFetch("/api/quote/log", {
        method: HttpMethod.Post,
        body: JSON.stringify(log),
        headers: {
            "content-type": "application/json"
        }
    });
};
